import { getRightList } from '@/infrastructure/api-functions';
import type { IRightListRequest } from '@/types';
import { ListBaseService } from '@eureka/solution-card';
import { type ISolutionListResponse } from '@eureka/solution-card/src/types';

export class ProjectDrawerListService extends ListBaseService {
    protected fetchData(
        data: IRightListRequest
    ): Promise<ISolutionListResponse> {
        return getRightList(data)
    }
}
